import { useRenderClock } from '../composables/date/useRenderClock'

/**
 * Moves the render clock from the server's moment to the browser's once
 * hydration is over. Until then the relative time labels format against the
 * moment the page was built, which is the only value that agrees with the HTML.
 * Set once, not on an interval, so the labels behave as they did before this
 * apart from the correction.
 */
export default defineNuxtPlugin({
  name: 'render-clock',
  setup(nuxtApp) {
    if (!nuxtApp.payload.serverRendered) return
    // Read here: onNuxtReady runs outside the Nuxt instance, and useState is
    // not reachable from there.
    const clock = useRenderClock()
    onNuxtReady(() => {
      clock.value = Date.now()
    })
  },
})
